import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ddgl",
  "use": "icon-ddgl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-ddgl\"><path fill=\"#fff\" fill-opacity=\".8\" fill-rule=\"evenodd\" d=\"M6.244 1.25h6.272L17.5 6.307l.006 8.79v1.153H5l.006-1.152L5 2.402l.006-1.152zm-.278 14.084 5.29-.334 5.336.334-.339-4.076.34-3.742H11.25l.04-5.39-2.54.374-2.784-.374.287 6.624zm10.884-8.57-4.35-.498-.373-4.326 1.96 2.643zM2.5 17.515v1.25h11.25v-.625l-10-.625L3.125 6.25H2.5z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol